import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Staging-only: an open-but-idle tab regaining focus/reconnecting
      // otherwise refetches and generates outbound traffic, which blocks
      // Railway Serverless sleep just like an open DB connection does.
      ...(DISABLE_BACKGROUND_REFETCH && { refetchOnWindowFocus: false, refetchOnReconnect: false }),
    },
  },
});
